import { render, staticRenderFns } from "./StudyResultsEditColumnsDrawer.vue?vue&type=template&id=dc172af8&scoped=true&"
import script from "./StudyResultsEditColumnsDrawer.vue?vue&type=script&lang=js&"
export * from "./StudyResultsEditColumnsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./StudyResultsEditColumnsDrawer.vue?vue&type=style&index=0&id=dc172af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc172af8",
  null
  
)

export default component.exports